import React, { useEffect, useState } from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import "../assets/style.scss"

type PropsType = {
  configValue: string
}

const LandingHeader = ({ configValue }: PropsType) => {

  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Row>
        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
          <div className="bapp-container">
            <Block className="landing-header-text-wrapper" dangerouslySetInnerHTML={{ __html: configValue }} />
            <Image
              path={"./img/birebirbankaciliklead/bire-bir-bankacilik.png"}
              className="landing-header-img"
            />
          </div>
        </Col>
      </Row>
    </Block>
  )
}

export default LandingHeader
